import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, timeout: 45000 });

// One in-flight/settled request per path+params per page load: dedupes the menus/dishes fetches without persisting anything.
const once = new Map();
export const getOnce = (path, params) => {
  const k = path + JSON.stringify(params || {});
  if (!once.has(k)) once.set(k, api.get(path, { params }).then((r) => r.data).catch((e) => { once.delete(k); throw e; }));
  return once.get(k);
};

export const squareSet = (u) => (u ? [400, 800, 1200].map((w) => `${assetUrl(w === 1200 ? u : u.replace(/\.webp$/, `-${w}.webp`))} ${w}w`).join(", ") : undefined);

export const assetUrl = (path) => (path ? (/^https?:/.test(path) ? path : `${BACKEND_URL}${path}`) : null);
export const assetSrcSet = (s) => (s ? s.split(",").map((e) => { const [u, w] = e.trim().split(/\s+/); return `${assetUrl(u)} ${w || ""}`.trim(); }).join(", ") : undefined);

export const formatPrice = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export function filtersToParams(f) {
  const p = {};
  if (f.avoid.length) p.avoid = f.avoid.join(",");
  if (f.diet.length) p.diet = f.diet.join(",");
  if (f.taste.length) p.taste = f.taste.join(",");
  return p;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
}

export const withOverrides = (dish, menuKey) =>
  menuKey && dish.menu_overrides?.[menuKey] ? { ...dish, ...dish.menu_overrides[menuKey] } : dish;
